import { useCallback, useEffect, useRef, useState } from "react";

import { PurchasableProducts } from "@/pages/shopAll/types";
import { careService } from "@/services/care";

// Fetches once `enabled` and again when `refetchKey` changes identity; `refetch` fetches regardless of `enabled`.
export const usePurchasableProducts = (
  enabled: boolean,
  refetchKey: unknown
) => {
  const [data, setData] = useState<PurchasableProducts>();
  const [error, setError] = useState<unknown>();
  const [loading, setLoading] = useState(false);
  const latestRequest = useRef(0);

  const fetchPurchasableProducts = useCallback(async () => {
    const request = ++latestRequest.current;
    setLoading(true);
    try {
      const response = await careService.asyncFetchPurchasableProducts();
      if (request === latestRequest.current) {
        setData(response.data);
        setError(undefined);
      }
    } catch (error) {
      console.error("Failed to fetch purchasable products:", error);
      if (request === latestRequest.current) setError(error);
    } finally {
      if (request === latestRequest.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) fetchPurchasableProducts();
  }, [enabled, refetchKey, fetchPurchasableProducts]);

  return {
    purchasableProducts: data,
    error,
    loading,
    refetch: fetchPurchasableProducts,
  };
};
